import { render, staticRenderFns } from "./Nickname.vue?vue&type=template&id=01fe4f86&scoped=true&"
import script from "./Nickname.vue?vue&type=script&lang=js&"
export * from "./Nickname.vue?vue&type=script&lang=js&"
import style0 from "./Nickname.vue?vue&type=style&index=0&id=01fe4f86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe4f86",
  null
  
)

export default component.exports